// ABOUTME: Mounts the city community-results Vue island.
// ABOUTME: Cards and hearts are the shared community-search component.

import './main.css';

import { createApp } from 'vue';

import App from './App.vue';

createApp(App).mount('#city-vue-app');
